import { render } from "./NavBarNotificationComp.vue?vue&type=template&id=fcf71fea"
import script from "./NavBarNotificationComp.vue?vue&type=script&lang=js"
export * from "./NavBarNotificationComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__